import { SvgIcon, SvgIconProps } from './SvgIcon';

// Material Icons "touch_app" (Apache 2.0), authored on a 24x24 grid.
export const TouchAppIcon = ({ viewBox, ...rest }: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...rest} viewBox={viewBox ?? '0 0 24 24'}>
      <path
        d="M9,11.24V7.5C9,6.12,10.12,5,11.5,5S14,6.12,14,7.5v3.74c1.21-0.81,2-2.18,2-3.74C16,5.01,13.99,3,11.5,3S7,5.01,7,7.5 C7,9.06,7.79,10.43,9,11.24z M18.84,15.87l-4.54-2.26c-0.17-0.07-0.35-0.11-0.54-0.11H13v-6C13,6.67,12.33,6,11.5,6 S10,6.67,10,7.5v10.74c-3.6-0.76-3.54-0.75-3.67-0.75c-0.31,0-0.59,0.13-0.79,0.33l-0.79,0.8l4.94,4.94 C9.96,23.83,10.34,24,10.75,24h6.79c0.75,0,1.33-0.55,1.44-1.28l0.75-5.27c0.01-0.07,0.02-0.14,0.02-0.2 C19.75,16.63,19.37,16.09,18.84,15.87z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
